export default __webpack_public_path__ + "static/media/T12.2cdd96c6.png";